import { render, staticRenderFns } from "./schoolFinIndex.vue?vue&type=template&id=3abe66cf&scoped=true"
import script from "./schoolFinIndex.vue?vue&type=script&lang=js"
export * from "./schoolFinIndex.vue?vue&type=script&lang=js"
import style0 from "./schoolFinIndex.vue?vue&type=style&index=0&id=3abe66cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe66cf",
  null
  
)

export default component.exports